import React from 'react';
import { MotifSelect, MotifOption } from '@ey-xd/motif-react';
import { FC } from 'react';

export interface SelectOption {
    value: string;
    label: string;
}

type SelectProps = {
    id?: string;
    value: string;
    options?: SelectOption[];
    placeholder?: string;
    className?: string;
    filter?: boolean;
    disabled?: boolean;
    ariaLabelledBy?: string;
    multiple?: boolean;
    visibleOptions?: number;
    children?: React.ReactNode;
    optionClassName?: string;
    onChange: (selectedValue: any) => void;
    onBlur?: (evt: any) => void;
};
const Select: FC<SelectProps> = ({
    id,
    value,
    options,
    placeholder,
    className,
    filter,
    disabled,
    optionClassName,
    ariaLabelledBy,
    multiple,
    visibleOptions,
    onChange,
    onBlur
}: SelectProps) => {
    return (
        <MotifSelect
            id={id}
            value={value}
            name="motif-select-name"
            placeholder={placeholder}
            className={className}
            filter={filter}
            disabled={disabled}
            onChange={onChange}
            ariaLabelledBy={ariaLabelledBy}
            onBlur={onBlur}
            multiple={multiple}
            visibleOptions={visibleOptions}>
            {options?.map((option, index) => {
                return (
                    <MotifOption
                        key={index + option.value}
                        value={option.value}
                        className={optionClassName}>
                        {option.label}
                    </MotifOption>
                );
            })}
        </MotifSelect>
    );
};
export default Select;
